import { render, staticRenderFns } from "./UnboxHeaderOverview.vue?vue&type=template&id=27a019de&scoped=true"
import script from "./UnboxHeaderOverview.vue?vue&type=script&lang=js"
export * from "./UnboxHeaderOverview.vue?vue&type=script&lang=js"
import style0 from "./UnboxHeaderOverview.vue?vue&type=style&index=0&id=27a019de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a019de",
  null
  
)

export default component.exports